import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';

const URL = 'https://evening-anchorage-3159.herokuapp.com/api/';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent {
  @Input() requiredFileType!: string;
  @Input() multiple!: string;
  @Output() fileOutput = new EventEmitter<any>();

  // uploader: FileUploader;
  hasBaseDropZoneOver: boolean;
  hasAnotherDropZoneOver: boolean;
  response: string;

  // First Custom file upload
  fileName = '';
  // uploadProgress!: number;
  // uploadSub!: Subscription;

  constructor(private http: HttpClient) {

    this.hasBaseDropZoneOver = false;
    this.hasAnotherDropZoneOver = false;
    this.response = '';
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }


  fileDrop(e: any) {
    const file: File = e[0];
    if (file) {
      this.fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileOutput.emit(reader.result);
      };
    }
  }

  //First custom file upload
  onFileSelected(event: any) {
    const file: File = event[0];
    if (file) {
      this.fileName = file.name;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.fileOutput.emit(reader.result);
      };
    }
  }
}
